import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const SittersPage = lazy(() => import('../pages/sitters/page'));
const SitterDetailPage = lazy(() => import('../pages/sitter-detail/page'));
const BookingPage = lazy(() => import('../pages/booking/page'));
const SitterRegistrationPage = lazy(() => import('../pages/sitter-registration/page'));
const SitterApplicationStatusPage = lazy(() => import('../pages/sitter-application-status/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const GuaranteePage = lazy(() => import('../pages/guarantee/page'));
const SitterTermsPage = lazy(() => import('../pages/sitter-terms/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const RoleSelectPage = lazy(() => import('../pages/role-select/page'));
const DashboardOwnerPage = lazy(() => import('../pages/dashboard/owner/page'));
const DashboardSitterPage = lazy(() => import('../pages/dashboard/sitter/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/sitters',
    element: <SittersPage />,
  },
  {
    path: '/sitters/:id',
    element: <SitterDetailPage />,
  },
  {
    path: '/booking',
    element: <BookingPage />,
  },
  {
    path: '/sitter-registration',
    element: <SitterRegistrationPage />,
  },
  {
    path: '/sitter-application-status',
    element: <SitterApplicationStatusPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '/guarantee',
    element: <GuaranteePage />,
  },
  {
    path: '/sitter-terms',
    element: <SitterTermsPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/role-select',
    element: <RoleSelectPage />,
  },
  {
    path: '/dashboard/owner',
    element: <DashboardOwnerPage />,
  },
  {
    path: '/dashboard/sitter',
    element: <DashboardSitterPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;